import * as React from 'react'
import { Text } from '@amzn/dvui/dist/Text'
import { PrimaryButton } from '@amzn/dvui/dist/Button'

export interface IDisneyActionProps {
  message?: string,
  returnLink?: string
}

export const DisneyAction = ({ message, returnLink }: IDisneyActionProps) => {
  if (!message || !returnLink) {
    return null
  }

  return (
    <div className="avu-full-width-phablet dv-dp-node-dma" data-automation-id="dma-button">
      <PrimaryButton href={returnLink} forceDoubleHeight={true} >
        <Text tag="span" string={message} />
      </PrimaryButton>
    </div>
  )
}
